export const BASIC_MONTHLY = 1;
export const BASIC_QUARTERLY = 2;
export const BASIC_YEARLY = 3;
export const ENTERPRISE_MONTHLY = 4;
export const ENTERPRISE_QUARTERLY = 5;
export const ENTERPRISE_YEARLY = 6;
